// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3730":"458bc7d3","3959":"fcb3fb10","4482":"6106c27f"}[chunkId] + ".chunk.css";
};